<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M24 4.20676V21H20.412L12.362 9.95022C10.8564 9.83979 9.70851 8.48234 9.7745 6.89028C9.82333 5.8047 10.4267 4.83279 11.35 4.35247C12.2585 3.84612 13.3534 3.88774 14.225 4.46175C15.0917 5.02445 15.6054 6.03521 15.5705 7.10884C15.5591 7.39326 15.5128 7.67491 15.4325 7.94668L20.55 15.1473V4.2189L24 4.20676ZM4.588 4.20676L12.638 15.2444C14.0835 15.4713 15.1051 16.8573 14.9587 18.3925C14.8122 19.9278 13.5493 21.0708 12.09 20.9888C10.6307 20.9068 9.48983 19.6288 9.4985 18.0858C9.50892 17.8012 9.55533 17.5195 9.6365 17.2479L4.45 10.0716V21H1V4.20676H4.588Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNCIAConnect',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>